export const DUE_DAY_OPTIONS = [1, 5, 10, 15, 20, 25] as const

export type DueDayOption = typeof DUE_DAY_OPTIONS[number]

export function getDynamicDefaultDueDay(now: Date = new Date()): DueDayOption {
  const currentDay = now.getDate()
  return DUE_DAY_OPTIONS.find(option => option >= currentDay) ?? DUE_DAY_OPTIONS[0]
}

export function resolveDefaultDueDay(
  persisted: number | null | undefined,
  options: {
    isEditMode?: boolean
    isComplete?: boolean
    useDynamicDefault?: boolean
    now?: Date
  } = {},
): number | null {
  const {
    isEditMode = false,
    isComplete = false,
    useDynamicDefault = false,
    now = new Date(),
  } = options

  if (isEditMode)
    return persisted ?? null

  const isImplicitDefault = persisted == null || (persisted === 1 && !isComplete)
  if (isImplicitDefault)
    return useDynamicDefault ? getDynamicDefaultDueDay(now) : 1

  return persisted
}
